// transitionVariants.ts

export type TransitionVariantKey =
  | 'crossFade'
  | 'crossBlur'
  | 'slideFromRight'
  | 'slideFromLeft'
  | 'slideFromBottom'
  | 'slideFromTop'
  | 'cube'
  | 'none';

export interface TransitionVariant {
  initial: any;
  animate: any;
  exit: any;
  style?: object;
  transition: any;
}

export const transitionVariants: Record<TransitionVariantKey, TransitionVariant> = {
  crossFade: {
    initial: { opacity: 0 },
    animate: { opacity: 1, transition: { duration: 0.3 } },
    exit: { opacity: 0, transition: { duration: 0.2 } },
    transition: { duration: 0.3 }
  },
  crossBlur: {
    initial: { opacity: 0, filter: 'blur(16px)' },
    animate: { opacity: 1, filter: 'blur(0px)', transition: { duration: 0.4 } },
    exit: { opacity: 0, filter: 'blur(16px)', transition: { duration: 0.2 } },
    transition: { duration: 0.4 }
  },
  slideFromRight: {
    initial: { x: '100%', opacity: 0 },
    animate: { x: 0, opacity: 1, transition: { duration: 0.3 } },
    exit: { x: '-100%', opacity: 0, transition: { duration: 0.2 } },
    transition: { duration: 0.3 }
  },
  slideFromLeft: {
    initial: { x: '-100%', opacity: 0 },
    animate: { x: 0, opacity: 1, transition: { duration: 0.3 } },
    exit: { x: '100%', opacity: 0, transition: { duration: 0.2 } },
    transition: { duration: 0.3 }
  },
  slideFromBottom: {
    initial: { y: '100%', opacity: 0 },
    animate: { y: 0, opacity: 1, transition: { duration: 0.3 } },
    exit: { y: '-100%', opacity: 0, transition: { duration: 0.2 } },
    transition: { duration: 0.3 }
  },
  slideFromTop: {
    initial: { y: '-100%', opacity: 0 },
    animate: { y: 0, opacity: 1, transition: { duration: 0.3 } },
    exit: { y: '100%', opacity: 0, transition: { duration: 0.2 } },
    transition: { duration: 0.3 }
  },
  cube: {
    initial: { rotateY: 90, opacity: 0 },
    animate: { rotateY: 0, opacity: 1, transition: { duration: 0.4 } },
    exit: { rotateY: -90, opacity: 0, transition: { duration: 0.2 } },
    transition: { duration: 0.4 }
  },
  none: {
    initial: { opacity: 1 },
    animate: { opacity: 1, transition: { duration: 0 } },
    exit: { opacity: 1, transition: { duration: 0 } },
    transition: { duration: 0 }
  }
};

export function getTransitionVariant(key: string): TransitionVariant {
  return transitionVariants[key as TransitionVariantKey] || transitionVariants.none;
}
